import { arcgisServerBaseUrl } from "./mapConfig";

export const apiUrl = "https://nvr-api-nvr2-prd.mapshare.vic.gov.au";

export const reportEndpoint = `${apiUrl}/report`;

export const adminReportEndpoint = `${apiUrl}/admin/report`;

export const adminExportEndpoint = `${apiUrl}/admin/export`;

export const exportShapefileTask =
  arcgisServerBaseUrl + "/NVR2/NVR_Utilities/GPServer/ExportToShapefile";

export const locationDetailsTask =
  arcgisServerBaseUrl + "/NVR2/NVR_Geoprocessing/GPServer/GetLocationDetails";

export const removalReportTask =
  arcgisServerBaseUrl +
  "/NVR2/NVR_Geoprocessing/GPServer/CalculateRemovalReportResults";

export const offsetReportTask =
  arcgisServerBaseUrl +
  "/NVR2/NVR_Geoprocessing/GPServer/CalculateOffsetReportResults";

export const removalUploadValidationTask =
  arcgisServerBaseUrl +
  "/NVR2/NVR_Geoprocessing/GPServer/ValidateDetailedRemovalFeatures";

export const offsetUploadValidationTask =
  arcgisServerBaseUrl +
  "/NVR2/NVR_Geoprocessing/GPServer/ValidateDetailedOffsetFeatures";

export const simplePolygonFields: any = [
  { name: "OBJECTID", type: "oid" },
  { name: "id", type: "string", length: 50 },
  { name: "type", type: "string", length: 50 },
];

export const simpleTreeFieldNames: any = {
  treeType: "type",
  cmType: "meas_type",
  cm: "meas",
  vegCode: "veg_code",
  benchmark: "lt_val",
};

export const simpleTreeFields: any = [
  { name: "OBJECTID", type: "oid" },
  { name: "id", type: "string", length: 50 },
  { name: simpleTreeFieldNames.treeType, type: "string", length: 50 },
  { name: simpleTreeFieldNames.cmType, type: "string", length: 50 },
  { name: simpleTreeFieldNames.cm, type: "double" },
  { name: simpleTreeFieldNames.vegCode, type: "string", length: 50 },
  { name: simpleTreeFieldNames.benchmark, type: "string", length: 50 },
];

export const detailedRemovalPatchFieldNames: any = {
  id: "id",
  siteId: "site_id",
  zoneId: "zone_id",
  propId: "prop_id",
  type: "type",
  cp: "cp",
  vegCodes: "veg_codes",
  isPast: "is_past",
  isPartial: "is_partial",
  ltCount: "lt_count",
  condScore: "cond_score",
  condPart: "cond_part",
  survDate: "surv_date",
  excHims: "exc_hims",
};

export const detailedRemovalPatchFields: any = [
  { name: detailedRemovalPatchFieldNames.id, type: "string", length: 50 },
  { name: detailedRemovalPatchFieldNames.siteId, type: "string", length: 50 },
  { name: detailedRemovalPatchFieldNames.zoneId, type: "string", length: 50 },
  { name: detailedRemovalPatchFieldNames.propId, type: "string", length: 50 },
  { name: detailedRemovalPatchFieldNames.type, type: "string", length: 50 },
  { name: detailedRemovalPatchFieldNames.cp, type: "string", length: 50 },
  { name: detailedRemovalPatchFieldNames.vegCodes, type: "string", length: 50 },
  { name: detailedRemovalPatchFieldNames.isPast, type: "string", length: 50 },
  {
    name: detailedRemovalPatchFieldNames.isPartial,
    type: "string",
    length: 50,
  },
  { name: detailedRemovalPatchFieldNames.ltCount, type: "integer", length: 50 },
  {
    name: detailedRemovalPatchFieldNames.condScore,
    type: "double",
    length: 50,
  },
  { name: detailedRemovalPatchFieldNames.condPart, type: "double", length: 50 },
  {
    name: detailedRemovalPatchFieldNames.survDate,
    type: "integer",
    length: 50,
  },
  { name: detailedRemovalPatchFieldNames.excHims, type: "string", length: 50 },
];

export const detailedRemovalTreeFieldNames: any = {
  id: "id",
  siteId: "site_id",
  zoneId: "zone_id",
  propId: "prop_id",
  type: "type",
  measType: "meas_type",
  meas: "meas",
  ltVal: "lt_val",
  cp: "cp",
  vegCode: "veg_code",
  isPast: "is_past",
  isPartial: "is_partial",
  ltCount: "lt_count",
  condScore: "cond_score",
  condPart: "cond_part",
  survDate: "surv_date",
  excHims: "exc_hims",
};

export const detailedRemovalTreeFields: any = [
  { name: detailedRemovalTreeFieldNames.id, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.siteId, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.zoneId, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.propId, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.type, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.measType, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.meas, type: "double", length: 50 },
  { name: detailedRemovalTreeFieldNames.ltVal, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.cp, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.vegCode, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.isPast, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.isPartial, type: "string", length: 50 },
  { name: detailedRemovalTreeFieldNames.ltCount, type: "integer", length: 50 },
  { name: detailedRemovalTreeFieldNames.condScore, type: "double", length: 50 },
  { name: detailedRemovalTreeFieldNames.condPart, type: "double", length: 50 },
  { name: detailedRemovalTreeFieldNames.survDate, type: "integer", length: 50 },
  { name: detailedRemovalTreeFieldNames.excHims, type: "string", length: 50 },
];

export const detailedOffsetPatchFieldNames: any = {
  id: "id",
  siteId: "site_id",
  zoneId: "zone_id",
  propId: "prop_id",
  vlot: "vlot",
  lot: "lot",
  recruits: "recruits",
  type: "type",
  cp: "cp",
  vegCodes: "veg_codes",
  ltCount: "lt_count",
  condScore: "cond_score",
  gainScore: "gain_score",
  survDate: "surv_date",
  incHims: "inc_hims",
  incHis: "inc_his",
  excHims: "exc_hims",
};

export const detailedOffsetPatchFields: any = [
  { name: detailedOffsetPatchFieldNames.id, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.siteId, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.zoneId, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.propId, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.vlot, type: "double", length: 50 },
  { name: detailedOffsetPatchFieldNames.lot, type: "double", length: 50 },
  { name: detailedOffsetPatchFieldNames.recruits, type: "double", length: 50 },
  { name: detailedOffsetPatchFieldNames.type, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.cp, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.vegCodes, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.ltCount, type: "integer", length: 50 },
  { name: detailedOffsetPatchFieldNames.condScore, type: "double", length: 50 },
  { name: detailedOffsetPatchFieldNames.gainScore, type: "double", length: 50 },
  { name: detailedOffsetPatchFieldNames.survDate, type: "integer", length: 50 },
  { name: detailedOffsetPatchFieldNames.incHims, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.incHis, type: "string", length: 50 },
  { name: detailedOffsetPatchFieldNames.excHims, type: "string", length: 50 },
];

export const detailedRevegetationFieldNames: any = {
  id: "id",
  siteId: "site_id",
  zoneId: "zone_id",
  propId: "prop_id",
  vlot: "vlot",
  lot: "lot",
  recruits: "recruits",
  type: "type",
  cp: "cp",
  vegCodes: "veg_codes",
  condScore: "cond_score",
  gainScore: "gain_score",
  survDate: "surv_date",
  incHims: "inc_hims",
  incHis: "inc_his",
  excHims: "exc_hims",
};

export const detailedRevegetationFields: any = [
  { name: detailedRevegetationFieldNames.id, type: "string", length: 50 },
  { name: detailedRevegetationFieldNames.siteId, type: "string", length: 50 },
  { name: detailedRevegetationFieldNames.zoneId, type: "string", length: 50 },
  { name: detailedRevegetationFieldNames.propId, type: "string", length: 50 },
  { name: detailedRevegetationFieldNames.vlot, type: "double", length: 50 },
  { name: detailedRevegetationFieldNames.lot, type: "double", length: 50 },
  { name: detailedRevegetationFieldNames.recruits, type: "double", length: 50 },
  { name: detailedRevegetationFieldNames.type, type: "string", length: 50 },
  { name: detailedRevegetationFieldNames.cp, type: "string", length: 50 },
  { name: detailedRevegetationFieldNames.vegCodes, type: "string", length: 50 },
  {
    name: detailedRevegetationFieldNames.condScore,
    type: "double",
    length: 50,
  },
  {
    name: detailedRevegetationFieldNames.gainScore,
    type: "double",
    length: 50,
  },
  {
    name: detailedRevegetationFieldNames.survDate,
    type: "integer",
    length: 50,
  },
  { name: detailedRevegetationFieldNames.incHims, type: "string", length: 50 },
  { name: detailedRevegetationFieldNames.incHis, type: "string", length: 50 },
  { name: detailedRevegetationFieldNames.excHims, type: "string", length: 50 },
];

export const detailedOffsetTreeFieldNames: any = {
  id: "id",
  siteId: "site_id",
  zoneId: "zone_id",
  propId: "prop_id",
  vlot: "vlot",
  lot: "lot",
  recruits: "recruits",
  type: "type",
  measType: "meas_type",
  meas: "meas",
  vegCode: "veg_code",
  ltVal: "lt_val",
  treeRad: "tree_rad",
  cp: "cp",
  condScore: "cond_score",
  gainScore: "gain_score",
  survDate: "surv_date",
  incHims: "inc_hims",
  incHis: "inc_his",
  excHims: "exc_hims",
};

export const detailedOffsetTreeFields: any = [
  { name: detailedOffsetTreeFieldNames.id, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.siteId, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.zoneId, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.propId, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.vlot, type: "double", length: 50 },
  { name: detailedOffsetTreeFieldNames.lot, type: "double", length: 50 },
  { name: detailedOffsetTreeFieldNames.recruits, type: "double", length: 50 },
  { name: detailedOffsetTreeFieldNames.type, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.measType, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.meas, type: "double", length: 50 },
  { name: detailedOffsetTreeFieldNames.vegCode, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.ltVal, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.treeRad, type: "double", length: 50 },
  { name: detailedOffsetTreeFieldNames.cp, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.condScore, type: "double", length: 50 },
  { name: detailedOffsetTreeFieldNames.gainScore, type: "double", length: 50 },
  { name: detailedOffsetTreeFieldNames.survDate, type: "integer", length: 50 },
  { name: detailedOffsetTreeFieldNames.incHims, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.incHis, type: "string", length: 50 },
  { name: detailedOffsetTreeFieldNames.excHims, type: "string", length: 50 },
];

export const locationDetailsParams = {
  addresses: { index: 0 },
  localGovernmentAreas: { index: 1 },
  catchmentManagementAuthorities: { index: 2 },
  registeredAboriginalParties: { index: 3 },
  featuresCentroid: { index: 4 },
};

export const removalReportOutputParams = {
  proposedRemovalArea: { index: 0 },
  totalRemovalArea: { index: 1, label: "Total extent", unit: "ha" },
  treesLargeCount: { index: 2, label: "Large Trees" },
  patchesArea: { index: 3, label: "Proposed removal - Patches", unit: "ha" },
  endangeredEvcsRemovalArea: {
    index: 4,
    label: "Includes endangered EVCs",
    unit: "ha",
  },
  patchTreesLargeCount: { index: 5, label: "Large Patch Trees" },
  patchTreesArea: {
    index: 6,
    label: "Proposed removal - Patch Trees (outside of a mapped patch)",
    unit: "ha",
  },
  patchTreesSmallCount: { index: 7 },
  scatteredTreesArea: {
    index: 8,
    label: "Proposed removal - Scattered Trees",
    unit: "ha",
  },
  scatteredTreesSmallCount: { index: 9, label: "Small Scattered Trees" },
  scatteredTreesLargeCount: { index: 10, label: "Large Scattered Trees" },
  locationRisk: { index: 11 },
  assessmentPathway: { index: 12 },
  generalOffsetAmount: {
    index: 13,
    label: "General offset amount",
    unit: "General Habitat Units",
  },
  minimumStrategicBiodiversityScore: {
    index: 14,
    label: "Minimum strategic biodiversity value score",
  },
  outputPastRemovalArea: {
    index: 17,
    label: "Past removal",
    unit: "ha",
  },
};

export const offsetReportOutputParams = {
  totalOffsetArea: { index: 0, label: "Total extent", unit: "ha" },
  treesLargeCount: { index: 1, label: "Large Trees" },
  patchesArea: { index: 2, label: "Patches", unit: "ha" },
  scatteredTreesArea: { index: 3, label: "Scattered Trees", unit: "ha" },
  revegetationAreasArea: { index: 4, label: "Revegetation", unit: "ha" },
  habitatGain: { index: 5, label: "General Habitat Units" },
  strategicBiodiversityScore: {
    index: 6,
    label: "Strategic Biodiversity Value Score",
  },
};
